// firebase/config.js

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCYnj4ksKBkRhlC4Ueq_F8H-cbnQxoWQSk",
    authDomain: "contactform-1df6d.firebaseapp.com",
    databaseURL: "https://contactform-1df6d-default-rtdb.firebaseio.com",
    projectId: "contactform-1df6d",
    storageBucket: "contactform-1df6d.appspot.com",
    messagingSenderId: "439970026347",
    appId: "1:439970026347:web:d0365cee6cca99f8f3722e"
};
// Initialize Firebase app
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firestore
const projectFirestore = getFirestore(firebaseApp);

export { projectFirestore };
